import { Route, BrowserRouter, Routes} from 'react-router-dom'
import './App.css';
import Home from './Home';
import Entree from './components/Entree';
import Soup from './components/Soup';
import Appetizers from './components/Appetizer';
import Dessert from './components/Dessert';
import Recipe from './components/Recipe';



function App() {

  
  return (

   
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path="/category/Entree/" element={<Entree/>}/>
          <Route path="/category/Entree/:recipeId/:recipeName" element={<Recipe/>} exact/>
          <Route path="/category/Soup/" element={<Soup/>}/>
          <Route path="/category/Soup/:recipeId/:recipeName" element={<Recipe/>} exact/>
          <Route path="/category/Dessert/" element={<Dessert/>}/>
          <Route path="/category/Dessert/:recipeId/:recipeName" element={<Recipe/>} exact/>
          <Route path="/category/Appetizers/" element={<Appetizers/>}/>
          <Route path="/category/Appetizers/:recipeId/:recipeName" element={<Recipe/>} exact/>
        </Routes>
      </BrowserRouter>
   
  );
}

export default App;
